module.exports = __webpack_public_path__ + "img/prescription.dd78519f.svg";